import colors from "assets/theme/base/colors"
import MDBox from "components/atoms/MDBox/MDBox"
import MDButton from "components/atoms/MDButton/MDButton"
import { routesMap } from "data/routes"
import { useAuth } from "hooks/useAuth"
import { RouteKeys } from "models/RouteModels"
import { useNavigate } from "react-router-dom"

const OnboardingErrorMessageStep: React.FC = () => {

    const {
        signOut,
    } = useAuth();

    const navigate = useNavigate();

    const handleLogOut = () => {
        signOut();

        navigate(`${routesMap[RouteKeys.SIGN_IN].route}?unauthorized=true`)
    }

    return (
        <MDBox display="grid" justifyContent="center">
            <div style={{
                marginBottom: "2rem",
                maxWidth: "15rem",
                fontSize: "1.4rem",
                textAlign: "center"
            }}>
                <span style={{ color: colors.white.main, fontWeight: 400, }}>
                    An unexpected error has occurred while attempting to create your account. Please contact your jointAi admin to resolve this issue and try again.
                </span>
            </div>
            <MDBox display="grid" marginTop="1.5rem">
                <MDButton
                    variant='contained'
                    style={{ color: colors.text.main }}
                    onClick={handleLogOut}>
                    Continue
                </MDButton>
            </MDBox>
        </MDBox>
    )
}

export default OnboardingErrorMessageStep 